import { Injectable } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	Router,
	RouterStateSnapshot
} from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable()
export class ChangePasswordGuard {
	constructor(private router: Router) {}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean> {
		return this._checkActivation(route, state);
	}

	canActivateChild(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean> {
		return this._checkActivation(route, state);
	}

	private _checkActivation(
		route: ActivatedRouteSnapshot,
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		state: RouterStateSnapshot
	): Observable<boolean> {
		if (route.queryParamMap.get('Token')) {
			return of(true);
		}
		this.router.navigate(['auth', 'login']);
		return of(false);
	}
}
